// import "./App.css";
// import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
// import InterviewScheduleForm from "./pages/InterviewScheduleForm";
// import InterviewVideoCallPage from "./pages/InterviewScheduleForm/InterviewVideoCallPage";
// import Header from "./pages/Header";
// import Footer from "./pages/Footer";
// import Loading from "./Components/loading";
// import { useEffect, useState } from "react";
// import CandidateDashboard from "./pages/CandidateDashboard";
// import { HTML5Backend } from "react-dnd-html5-backend";
// import { Toaster } from "react-hot-toast";
// import UploadForm from "./pages/InterviewScheduleForm/UploadForm";
// import { DndProvider } from "react-dnd";
// import SetUpInterview from "./pages/InterviewScheduleForm/setUpInterview";
// import LoginForm from "./pages/Login";
// import SignUp from "./pages/SignUp/SignUp";

// function App() {
//   const [loading, setLoading] = useState(true);
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setLoading(false);
//     }, 3000); // 3 seconds

//     return () => clearTimeout(timer);
//   }, []);

//   if (loading) {
//     return <Loading />;
//   }

//   const isLoggedIn = () => {
//     console.log("****Hello****");

//     let loggedIn = localStorage.getItem("access_token");
//     if (!loggedIn) {
//       console.log("****HI*****");

//       window.location.replace("");
//     }
//   };

//   return (
//     <BrowserRouter>
//       <DndProvider backend={HTML5Backend}>
//         <Header />
//         <Routes>
//           <Route
//             path="/create-position"
//             element={<InterviewScheduleForm />}
//             loader={() => console.log("****Hello****")}
//           />
//           <Route
//             path="/interview-video-call"
//             element={<InterviewVideoCallPage />}
//           />
//           <Route path="/candidate-dashboard" element={<CandidateDashboard />} />
//           <Route path="/upload-form" element={<UploadForm />} />
//           <Route path="/setup-interview" element={<SetUpInterview />} />
//           <Route path="/" element={<LoginForm />} />
//           <Route path="/sign-up" element={<SignUp />} />
//         </Routes>
//         <Footer />
//         <Toaster position="top-center" />
//       </DndProvider>
//     </BrowserRouter>
//   );
// }

// export default App;

import "./App.css";
import { RouterProvider } from "react-router-dom";
import { useEffect, useState } from "react";
import Loading from "./Components/loading";
import router from "./router";
import { Toaster } from "react-hot-toast";
import Footer from "./pages/Footer";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 3000); // 3 seconds

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <Loading />;
  }

  return (
    <>
      <RouterProvider router={router} />
      <Toaster position="top-center" />
      <Footer />
    </>
  );
}

export default App;
